module.exports = __webpack_public_path__ + "static/media/1-6.8d7f8396.svg";